var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cont-lineage-iframe" }, [
    _c("h5", { staticClass: "title-section" }, [_vm._v("Lineage")]),
    _c(
      "article",
      { staticClass: "cont-iframe", attrs: { id: "SECTION" } },
      [
        _c(
          "b-card",
          [
            _c(
              "b-row",
              _vm._l(_vm.uris, function (uri) {
                return _vm.uris && _vm.uris.length
                  ? _c("b-col", { key: uri.id, attrs: { sm: "12" } }, [
                      _c("a", { attrs: { href: uri, target: "_blank" } }, [
                        _vm._v("Open in new window"),
                        _c("i", { staticClass: "material-icons md-16" }, [
                          _vm._v("open_in_new"),
                        ]),
                      ]),
                      _c("img", { attrs: { src: _vm.image } }),
                    ])
                  : _c("b-col", { attrs: { sm: "12" } }, [
                      _vm._v("Not found info"),
                    ])
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }